import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as AntCheckbox } from "antd";
import classNames from "classnames";
import { styleClasses } from "../../helpers";
import "./Checkbox.scss";
const CSS_PREFIX = `lav-components-checkbox`;
export const Checkbox = (_a) => {
    var { className = "", clear, radius = "sm", size = "small" } = _a, antCheckboxProps = __rest(_a, ["className", "clear", "radius", "size"]);
    return (_jsx(AntCheckbox, Object.assign({ className: classNames(styleClasses(CSS_PREFIX, { clear, radius, size }), {
            [className]: !!className,
        }) }, antCheckboxProps)));
};
